const diagnosticForm = document.getElementById("diagnosticForm");
const calendarStep = document.getElementById("calendarStep");
const formStatus = document.getElementById("formStatus");
const challenge = diagnosticForm?.querySelector("textarea[name='challenge']");
const challengeCount = document.getElementById("challengeCount");
const schedulerLoading = document.getElementById("schedulerLoading");
const schedulerPicker = document.getElementById("schedulerPicker");
const schedulerDays = document.getElementById("schedulerDays");
const schedulerTimes = document.getElementById("schedulerTimes");
const schedulerSlots = document.getElementById("schedulerSlots");
const schedulerTimesLabel = document.getElementById("schedulerTimesLabel");
const schedulerSummary = document.getElementById("schedulerSummary");
const schedulerSelected = document.getElementById("schedulerSelected");
const schedulerConfirm = document.getElementById("schedulerConfirm");
const calendarFallback = document.getElementById("calendarFallback");
const schedulerConfirmation = document.getElementById("schedulerConfirmation");
const confirmationDate = document.getElementById("confirmationDate");
const confirmationTime = document.getElementById("confirmationTime");
const confirmationDuration = document.getElementById("confirmationDuration");

const leadEndpoint = import.meta.env.VITE_DIAGNOSTIC_LEAD_ENDPOINT || "/api/diagnostic-leads";
const calendarEndpoint = import.meta.env.VITE_DIAGNOSTIC_CALENDAR_ENDPOINT || "/api/diagnostic-calendar";
const submissionTokenKey = "automat_diagnostic_submission_token";
const previewMode = import.meta.env.DEV
  ? new URLSearchParams(window.location.search).get("scheduler_preview")
  : null;
let formStarted = false;
let schedulerState = {
  days: [],
  timezone: "America/Sao_Paulo",
  durationMinutes: 30,
  selectedDay: 0,
  selectedSlot: null,
};

function trackEvent(name, parameters = {}) {
  const payload = {
    event_category: "institutional_site",
    page_location: window.location.href,
    ...parameters,
  };
  if (typeof window.gtag === "function") {
    window.gtag("event", name, payload);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...payload });
}

document.addEventListener("click", (event) => {
  const tracked = event.target.closest("[data-track]");
  if (!tracked) return;
  const eventName = tracked.dataset.track;
  trackEvent(eventName, {
    cta_location: tracked.dataset.location || "unknown",
    link_url: tracked.href || undefined,
  });
  if (eventName === "whatsapp_fallback_clicked") {
    recordDiagnosticEvent(eventName, { location: tracked.dataset.location || "unknown" });
  }
});

function currentAttribution() {
  const params = new URLSearchParams(window.location.search);
  const keys = [
    "utm_source", "utm_medium", "utm_campaign", "utm_campaign_id", "utm_content",
    "utm_term", "utm_adset", "utm_adset_id", "utm_ad_id", "utm_placement",
    "fbclid", "gclid", "ttclid", "msclkid",
  ];
  return Object.fromEntries(
    keys.map((key) => [key, params.get(key)]).filter(([, value]) => value && value.length <= 300),
  );
}

function setFormStatus(message, tone = "") {
  if (!formStatus) return;
  formStatus.textContent = message;
  formStatus.className = `form-status${tone ? ` ${tone}` : ""}`;
}

function markInvalid(element, invalid) {
  if (!element) return;
  if (invalid) element.setAttribute("aria-invalid", "true");
  else element.removeAttribute("aria-invalid");
}

function validateForm(form) {
  const requiredFields = ["name", "email", "company", "role", "challenge"];
  let firstInvalid = null;
  requiredFields.forEach((fieldName) => {
    const field = form.elements.namedItem(fieldName);
    const invalid = !field?.value?.trim() || !field.checkValidity();
    markInvalid(field, invalid);
    if (invalid && !firstInvalid) firstInvalid = field;
  });
  const website = form.elements.namedItem("website");
  const websiteInvalid = Boolean(website?.value && !website.checkValidity());
  markInvalid(website, websiteInvalid);
  if (websiteInvalid && !firstInvalid) firstInvalid = website;

  if (firstInvalid) {
    const message = firstInvalid.name === "email"
      ? "Informe um e-mail válido para receber o convite da reunião."
      : websiteInvalid
        ? "Informe o site completo, começando por https://, ou deixe o campo vazio."
        : "Preencha os campos obrigatórios para continuar.";
    setFormStatus(message, "error");
    firstInvalid.focus();
    return false;
  }
  if (!form.querySelectorAll("input[name='interests']:checked").length) {
    setFormStatus("Selecione ao menos uma área que você gostaria de melhorar.", "error");
    form.querySelector("input[name='interests']")?.focus();
    return false;
  }
  if (!form.querySelector("input[name='companySize']:checked")) {
    setFormStatus("Selecione o tamanho da empresa para continuar.", "error");
    form.querySelector("input[name='companySize']")?.focus();
    return false;
  }
  setFormStatus("");
  return true;
}

function buildPayload(form) {
  const data = new FormData(form);
  return {
    name: String(data.get("name") || "").trim(),
    email: String(data.get("email") || "").trim(),
    company: String(data.get("company") || "").trim(),
    website: String(data.get("website") || "").trim(),
    role: String(data.get("role") || "").trim(),
    interests: data.getAll("interests").map(String),
    challenge: String(data.get("challenge") || "").trim(),
    companySize: String(data.get("companySize") || ""),
    websiteConfirmation: String(data.get("website_confirmation") || ""),
    sourcePage: `${window.location.origin}${window.location.pathname}`,
    referrer: document.referrer || null,
    utm: currentAttribution(),
  };
}

function schedulingToken() {
  return sessionStorage.getItem(submissionTokenKey);
}

async function patchLead(payload) {
  const token = schedulingToken();
  if (!token) return;
  await fetch(leadEndpoint, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, ...payload }),
    keepalive: true,
  });
}

async function updateSchedulingStatus(status) {
  try { await patchLead({ status }); } catch { /* CRM telemetry never blocks scheduling. */ }
}

async function recordDiagnosticEvent(eventName, metadata = {}) {
  try { await patchLead({ event: eventName, metadata }); } catch { /* best-effort */ }
}

function dateFormatter(options) {
  return new Intl.DateTimeFormat("pt-BR", { timeZone: schedulerState.timezone, ...options });
}

function previewAvailability() {
  const days = [];
  const cursor = new Date();
  cursor.setUTCDate(cursor.getUTCDate() + 2);
  while (days.length < 8) {
    const weekday = cursor.getUTCDay();
    if (weekday >= 1 && weekday <= 5) {
      const date = cursor.toISOString().slice(0, 10);
      days.push({
        date,
        slots: ["09:00", "09:30", "10:30", "11:00", "14:00", "15:30", "16:30"].map(
          (time) => new Date(`${date}T${time}:00-03:00`).toISOString(),
        ),
      });
    }
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }
  return {
    timezone: "America/Sao_Paulo",
    durationMinutes: 30,
    days,
  };
}

function formatDay(slot) {
  const date = new Date(slot);
  return {
    day: dateFormatter({ day: "2-digit" }).format(date),
    weekday: dateFormatter({ weekday: "short" }).format(date).replace(".", ""),
    month: dateFormatter({ month: "short" }).format(date).replace(".", ""),
  };
}

function formatTime(slot) {
  return dateFormatter({ hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date(slot));
}

function selectedCopy(slot, includeYear = false) {
  const options = {
    weekday: "long", day: "2-digit", month: "long",
    ...(includeYear ? { year: "numeric" } : {}),
  };
  return `${dateFormatter(options).format(new Date(slot))}, às ${formatTime(slot)}`;
}

function renderSlots(dayIndex) {
  const day = schedulerState.days[dayIndex];
  if (!day || !schedulerSlots) return;
  schedulerState.selectedDay = dayIndex;
  schedulerState.selectedSlot = null;
  schedulerSummary.hidden = true;

  schedulerDays.querySelectorAll(".scheduler-day").forEach((button, index) => {
    button.setAttribute("aria-selected", String(index === dayIndex));
    button.tabIndex = index === dayIndex ? 0 : -1;
    if (index === dayIndex) schedulerTimes?.setAttribute("aria-labelledby", button.id);
  });
  schedulerTimesLabel.textContent = `Horários em ${dateFormatter({
    weekday: "long", day: "2-digit", month: "long",
  }).format(new Date(day.slots[0]))}`;
  schedulerSlots.replaceChildren(
    ...day.slots.map((slot) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "scheduler-slot";
      button.setAttribute("role", "radio");
      button.setAttribute("aria-checked", "false");
      button.dataset.slot = slot;
      button.textContent = formatTime(slot);
      return button;
    }),
  );
}

function renderScheduler(data) {
  schedulerState = {
    days: Array.isArray(data.days) ? data.days : [],
    timezone: data.timezone || "America/Sao_Paulo",
    durationMinutes: data.durationMinutes || 30,
    selectedDay: 0,
    selectedSlot: null,
  };
  if (!schedulerState.days.length) throw new Error("empty_calendar");

  schedulerDays.replaceChildren(
    ...schedulerState.days.map((day, index) => {
      const copy = formatDay(day.slots[0]);
      const button = document.createElement("button");
      button.type = "button";
      button.className = "scheduler-day";
      button.setAttribute("role", "tab");
      button.setAttribute("aria-selected", String(index === 0));
      button.setAttribute("aria-controls", "schedulerTimes");
      button.id = `scheduler-day-${index}`;
      button.tabIndex = index === 0 ? 0 : -1;
      button.dataset.dayIndex = String(index);
      button.innerHTML = `<span class="scheduler-day-date">${copy.day}</span><span class="scheduler-day-copy"><strong>${copy.weekday}</strong><span>${copy.month}</span></span>`;
      return button;
    }),
  );
  renderSlots(0);
  schedulerLoading.hidden = true;
  schedulerPicker.hidden = false;
  calendarFallback.hidden = true;
}

function showConfirmation(booking) {
  schedulerPicker.hidden = true;
  schedulerLoading.hidden = true;
  calendarFallback.hidden = true;
  schedulerConfirmation.hidden = false;
  const scheduledAt = new Date(booking.scheduledAt);
  confirmationDate.textContent = dateFormatter({
    weekday: "short", day: "2-digit", month: "short", year: "numeric",
  }).format(scheduledAt);
  confirmationTime.textContent = formatTime(booking.scheduledAt);
  confirmationDuration.textContent = `${booking.durationMinutes || schedulerState.durationMinutes} minutos`;
  const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  schedulerConfirmation.scrollIntoView({ behavior, block: "center" });
}

function showCalendarFallback(reason = "calendar_unavailable") {
  schedulerLoading.hidden = true;
  schedulerPicker.hidden = true;
  schedulerConfirmation.hidden = true;
  calendarFallback.hidden = false;
  trackEvent("calendar_error", { reason });
  recordDiagnosticEvent("calendar_error", { reason });
}

async function loadCalendar() {
  const token = schedulingToken();
  if (!token) return showCalendarFallback("missing_token");
  schedulerLoading.hidden = false;
  schedulerPicker.hidden = true;
  calendarFallback.hidden = true;
  schedulerConfirmation.hidden = true;

  try {
    if (previewMode === "error") throw new Error("preview_error");
    if (previewMode) {
      renderScheduler(previewAvailability());
      return;
    }
    const response = await fetch(`${calendarEndpoint}?token=${encodeURIComponent(token)}`, {
      headers: { Accept: "application/json" },
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(response.status === 429 ? "rate_limited" : "calendar_unavailable");
    if (result.alreadyBooked && result.booking) {
      showConfirmation(result.booking);
      sessionStorage.removeItem(submissionTokenKey);
      return;
    }
    renderScheduler(result);
  } catch (error) {
    showCalendarFallback(error instanceof Error ? error.message : "calendar_unavailable");
  }
}

function showCalendar() {
  if (!diagnosticForm || !calendarStep) return;
  diagnosticForm.hidden = true;
  calendarStep.hidden = false;
  trackEvent("calendar_viewed", { provider: "google_calendar" });
  updateSchedulingStatus("calendar_viewed");
  const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  const navHeight = document.getElementById("nav")?.offsetHeight || 0;
  const top = window.scrollY + calendarStep.getBoundingClientRect().top - navHeight - 18;
  window.scrollTo({ top: Math.max(0, top), behavior });
  loadCalendar();
}

diagnosticForm?.addEventListener("focusin", () => {
  if (formStarted) return;
  formStarted = true;
  trackEvent("lead_form_started");
}, { once: true });

challenge?.addEventListener("input", () => {
  if (challengeCount) challengeCount.textContent = String(challenge.value.length);
  markInvalid(challenge, false);
});

diagnosticForm?.querySelectorAll("input, textarea").forEach((field) => {
  field.addEventListener("input", () => markInvalid(field, false));
});

diagnosticForm?.addEventListener("submit", async (event) => {
  event.preventDefault();
  if (!validateForm(diagnosticForm)) return;
  const submitButton = diagnosticForm.querySelector("button[type='submit']");
  const submitLabel = submitButton?.querySelector("span:first-child");
  const originalLabel = submitLabel?.textContent || "Continuar para o calendário";
  submitButton.disabled = true;
  submitButton.setAttribute("aria-busy", "true");
  if (submitLabel) submitLabel.textContent = "Registrando seu contexto…";
  setFormStatus("Enviando com segurança…");

  try {
    const response = previewMode
      ? { ok: true }
      : await fetch(leadEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(buildPayload(diagnosticForm)),
      });
    const result = previewMode
      ? { schedulingToken: "local-preview-token" }
      : await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || "Não foi possível registrar o diagnóstico.");
    if (!result.schedulingToken) throw new Error("Recebemos os dados, mas o calendário não respondeu.");

    sessionStorage.setItem(submissionTokenKey, result.schedulingToken);
    trackEvent("lead_form_submitted", {
      interests_count: diagnosticForm.querySelectorAll("input[name='interests']:checked").length,
      company_size: diagnosticForm.querySelector("input[name='companySize']:checked")?.value,
    });
    setFormStatus("Contexto registrado. Abrindo o calendário…", "success");
    showCalendar();
  } catch (error) {
    const message = error instanceof Error ? error.message : "Não foi possível enviar agora.";
    setFormStatus(`${message} Revise os dados ou fale conosco pelo WhatsApp.`, "error");
  } finally {
    submitButton.disabled = false;
    submitButton.removeAttribute("aria-busy");
    if (submitLabel) submitLabel.textContent = originalLabel;
  }
});

schedulerDays?.addEventListener("click", (event) => {
  const button = event.target.closest(".scheduler-day");
  if (!button) return;
  renderSlots(Number(button.dataset.dayIndex));
});

schedulerDays?.addEventListener("keydown", (event) => {
  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return;
  event.preventDefault();
  const buttons = Array.from(schedulerDays.querySelectorAll(".scheduler-day"));
  const current = buttons.indexOf(document.activeElement);
  let next = current;
  if (["ArrowRight", "ArrowDown"].includes(event.key)) next = (current + 1) % buttons.length;
  if (["ArrowLeft", "ArrowUp"].includes(event.key)) next = (current - 1 + buttons.length) % buttons.length;
  if (event.key === "Home") next = 0;
  if (event.key === "End") next = buttons.length - 1;
  buttons[next]?.focus();
  renderSlots(next);
});

function selectSlotButton(button) {
  schedulerSlots.querySelectorAll(".scheduler-slot").forEach((candidate) => {
    candidate.setAttribute("aria-checked", String(candidate === button));
  });
  schedulerState.selectedSlot = button.dataset.slot;
  schedulerSelected.textContent = selectedCopy(schedulerState.selectedSlot);
  schedulerSummary.hidden = false;
  trackEvent("calendar_slot_selected", { scheduled_at: schedulerState.selectedSlot });
  recordDiagnosticEvent("calendar_slot_selected", { scheduledAt: schedulerState.selectedSlot });
}

schedulerSlots?.addEventListener("click", (event) => {
  const button = event.target.closest(".scheduler-slot");
  if (!button) return;
  selectSlotButton(button);
});

schedulerSlots?.addEventListener("keydown", (event) => {
  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return;
  const buttons = Array.from(schedulerSlots.querySelectorAll(".scheduler-slot"));
  const current = Math.max(0, buttons.indexOf(document.activeElement));
  const columns = Math.max(1, getComputedStyle(schedulerSlots).gridTemplateColumns.split(" ").length);
  let next = current;
  if (event.key === "ArrowRight") next = Math.min(buttons.length - 1, current + 1);
  if (event.key === "ArrowLeft") next = Math.max(0, current - 1);
  if (event.key === "ArrowDown") next = Math.min(buttons.length - 1, current + columns);
  if (event.key === "ArrowUp") next = Math.max(0, current - columns);
  if (event.key === "Home") next = 0;
  if (event.key === "End") next = buttons.length - 1;
  if (next === current && !["Home", "End"].includes(event.key)) return;
  event.preventDefault();
  buttons[next]?.focus();
  selectSlotButton(buttons[next]);
});

schedulerConfirm?.addEventListener("click", async () => {
  const startsAt = schedulerState.selectedSlot;
  const token = schedulingToken();
  if (!startsAt || !token) return;
  const originalLabel = schedulerConfirm.textContent;
  schedulerConfirm.disabled = true;
  schedulerConfirm.setAttribute("aria-busy", "true");
  schedulerConfirm.textContent = "Confirmando…";

  try {
    if (previewMode) {
      const bookedAt = new Date().toISOString();
      const booking = {
        scheduledAt: startsAt,
        durationMinutes: schedulerState.durationMinutes,
        meetingUrl: "https://meet.google.com/preview-only",
        bookedAt,
      };
      trackEvent("meeting_scheduled", {
        provider: "google_calendar",
        scheduled_at: startsAt,
        duration_minutes: schedulerState.durationMinutes,
      });
      showConfirmation(booking);
      sessionStorage.removeItem(submissionTokenKey);
      return;
    }
    const response = await fetch(calendarEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, startsAt }),
    });
    const result = await response.json().catch(() => ({}));
    if (response.status === 409) {
      await loadCalendar();
      throw new Error("Esse horário acabou de ser reservado. Os horários foram atualizados.");
    }
    if (!response.ok || !result.booking) throw new Error(result.error || "Não foi possível confirmar o horário.");

    trackEvent("meeting_scheduled", {
      provider: "google_calendar",
      scheduled_at: result.booking.scheduledAt,
      duration_minutes: result.booking.durationMinutes,
    });
    showConfirmation(result.booking);
    sessionStorage.removeItem(submissionTokenKey);
  } catch (error) {
    const message = error instanceof Error ? error.message : "Não foi possível confirmar o horário.";
    if (message.includes("horário acabou")) {
      schedulerTimesLabel.textContent = message;
    } else {
      showCalendarFallback("booking_failed");
    }
  } finally {
    schedulerConfirm.disabled = false;
    schedulerConfirm.removeAttribute("aria-busy");
    schedulerConfirm.textContent = originalLabel;
  }
});

/* ---------- Product evidence tabs ---------- */
const evidencePanel = document.getElementById("evidencePanel");
const evidenceImage = document.getElementById("evidenceImage");
const evidenceCaption = document.getElementById("evidenceCaption");
const evidenceTabs = Array.from(document.querySelectorAll(".evidence-tabs [role='tab']"));

function selectEvidenceTab(tab) {
  evidenceTabs.forEach((candidate) => {
    const isSelected = candidate === tab;
    candidate.setAttribute("aria-selected", String(isSelected));
    candidate.tabIndex = isSelected ? 0 : -1;
  });
  evidencePanel?.classList.add("is-switching");
  const nextImage = new Image();
  nextImage.onload = () => {
    evidenceImage.src = tab.dataset.shot;
    evidenceImage.alt = tab.dataset.alt;
    evidenceCaption.textContent = tab.dataset.caption;
    evidencePanel?.classList.remove("is-switching");
  };
  nextImage.src = tab.dataset.shot;
}

evidenceTabs.forEach((tab, index) => {
  tab.addEventListener("click", () => selectEvidenceTab(tab));
  tab.addEventListener("keydown", (event) => {
    if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    if (event.key === "ArrowRight") nextIndex = (index + 1) % evidenceTabs.length;
    if (event.key === "ArrowLeft") nextIndex = (index - 1 + evidenceTabs.length) % evidenceTabs.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = evidenceTabs.length - 1;
    evidenceTabs[nextIndex].focus();
    selectEvidenceTab(evidenceTabs[nextIndex]);
  });
});
